import "./jobsection.scss";
import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Snackbar,
  CircularProgress,
  Chip,
  Typography,
} from "@mui/material";
import DataTable from "../../ui/data/DataTable";
import Modal from '@mui/material/Modal';
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form, Field } from "formik";
import { useState, useContext, useEffect, useMemo, useRef } from "react";
import { getRequestWithToken } from "../../utils/ApiRequests";
import { GlobalContext } from "../../components/GlobalStateProvide/GlobalStateProvider";
import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";
import { useNavigate } from "react-router-dom";
import { patchRequestWithToken } from "../../utils/ApiRequests";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { UpdateJobRejectValidationSchema } from "../../utils/Validations";
import { useMaterialReactTable } from "material-react-table";

import JobFormDetailsButton from "../../components/job/JobFormDetailsButton";
const AllJobs = () => {
  const [jobApproved, setJobApproved] = useState(false);
  const [jobRejectionForm, setJobRejectionForm] = useState(false);
  const [jobRejected, setJobRejected] = useState(false);
  const [allJobsData, setAllJobsData] = useState([]);
  const { handleSnackBar } = useContext(GlobalContext);

  const [rowCount, setRowCount] = useState(0);
  const [loadingDataInGrid, setLoadingDataInGrid] = useState(true);

  // const [canCreate, setCanCreate] = useState(false);
  // const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  const navigate = useNavigate();


  const [tabvalue, setTabValue] = React.useState(0);
  const [isTheDataLoaded, setIsTheDataLoaded] = useState(false);
  const [rejectingJob, setRejectingJob] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // const isManaged = false;
  // const isFeatured = false;
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Box>{children}</Box>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const currentTabSelect = (event, newValue) => {
    setTabValue(newValue);
    setAllJobsData([]);
    setIsTheDataLoaded(false);
    setShowColumnFilters(false);
    setColumnFilters([]);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 50,
      enableColumnActions: false,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        return <span>{row.index + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      accessorKey: "jobId",
      header: "Job Id",
      size: 150,
      Cell: ({ renderedCellValue, row }) => (
        <div className="cell-wrapper">
          {renderedCellValue}
          {row.original.applicantLimit > 15 && (
            <span className="paid-badge">PAID</span>
          )}
        </div>
      ),
    }
    ,
    {
      accessorKey: "jobRoleNameEn",
      header: "Job Title",
      size: 250,
      Cell: ({ renderedCellValue }) => (
        <div style={{ textTransform: "capitalize", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.4 }}>{renderedCellValue}</div>
      ),
      id: 'jobTitle'
    },
    {
      accessorKey: "job description",
      header: "Description",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const openDescription = () => {
          if (!canRead) return;
          window.open(`/posted-jobs/${row.original._id}`, "_blank")
        };
        return (
          <span
            style={{
              textDecoration: "underline",
              color: "blue",
              cursor: canRead ? "pointer" : "not-allowed"
            }}
            onClick={openDescription}
          >
            view
          </span>
        );
      },
    },
    {
      accessorKey: "formDetails",
      header: "Form Details",
      size: 130,
      enableColumnFilter: false,
      Cell: ({ row }) => canRead ? <JobFormDetailsButton job={row.original} /> : null,
    },
    {
      accessorKey: "state",
      header: "State",
      size: 150,
      accessorFn: (row) => row.jobDescription?.jobLocation?.state,
    },
    {
      accessorKey: "city",
      header: "City",
      size: 150,
      accessorFn: (row) => row.jobDescription?.jobLocation?.city,
    },
    // {
    //   accessorKey: "is_managed",
    //   header: "Managed",
    //   size: 120,
    //   enableColumnFilter: false,
    //   accessorFn: (row) => (row.is_managed ? "Yes" : "No"),
    // },
    {
      accessorKey: "date_and_time",
      header: "Date & Time",
      size: 240,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const fmt = (val) =>
          val
            ? new Date(val).toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            : "--";
        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", fontSize: "0.78rem" }}>
            <span><strong>Created:</strong> {fmt(row.original.createdAt)}</span>
            <Box
              sx={{
                bgcolor: "rgba(76, 175, 80, 0.12)",
                border: "1px solid rgba(76, 175, 80, 0.4)",
                borderRadius: "4px",
                px: "6px",
                py: "2px",
                color: "#2e7d32",
                fontWeight: 600,
              }}
            >
              <strong>Live At:</strong> {fmt(row.original.jobLiveAt)}
            </Box>
            <span><strong>Updated:</strong> {fmt(row.original.updatedAt)}</span>
          </Box>
        );
      },
    },
    {
      accessorKey: "company_name",
      header: "Company Name",
      size: 200,
      accessorFn: (row) => row.companyName,
    },
  ];

  const requestedColumns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 100,
      enableColumnActions: false,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        return <span>{row.index + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      accessorKey: "jobId",
      header: "Job Id",
      size: 150,
      Cell: ({ renderedCellValue, row }) => (
        <div className="cell-wrapper">
          {renderedCellValue}
          {row.original.applicantLimit > 15 && (
            <span className="paid-badge">PAID</span>
          )}
        </div>
      ),
    },
    {
      accessorKey: "jobRoleNameEn",
      header: "Job Title",
      size: 180,
      Cell: ({ renderedCellValue }) => (
        <div style={{ textTransform: "capitalize", whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.4 }}>{renderedCellValue}</div>
      ),
      id: 'jobTitle'
    },
    {
      accessorKey: "job description",
      header: "Job Description",
      size: 140,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const openDescription = () => {
          if (!canRead) return;
          window.open(`/posted-jobs/${row.original._id}`, "_blank")
        };
        return (
          <span
            style={{
              textDecoration: "underline",
              color: "blue",
              cursor: canRead ? "pointer" : "not-allowed"

            }}
            onClick={openDescription}
          >
            view
          </span>
        );
      },
    },
    {
      accessorKey: "formDetails",
      header: "Form Details",
      size: 130,
      enableColumnFilter: false,
      Cell: ({ row }) => canRead ? <JobFormDetailsButton job={row.original} /> : null,
    },
    {
      accessorKey: "state",
      header: "State",
      size: 130,
      accessorFn: (row) => row.jobDescription?.jobLocation?.state,
    },
    {
      accessorKey: "city",
      header: "City",
      size: 130,
      accessorFn: (row) => row.jobDescription?.jobLocation?.city,
    },
    {
      accessorKey: "is_managed",
      header: "Managed",
      size: 100,
      enableColumnFilter: false,
      accessorFn: (row) => (row.is_managed ? "Yes" : "No"),
    },
    {
      accessorKey: "date_and_time",
      header: "Date & Time",
      size: 240,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        const fmt = (val) =>
          val
            ? new Date(val).toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            : "--";
        return (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", fontSize: "0.78rem" }}>
            <span><strong>Created:</strong> {fmt(row.original.createdAt)}</span>
            <Box
              sx={{
                bgcolor: "rgba(76, 175, 80, 0.12)",
                border: "1px solid rgba(76, 175, 80, 0.4)",
                borderRadius: "4px",
                px: "6px",
                py: "2px",
                color: "#2e7d32",
                fontWeight: 600,
              }}
            >
              <strong>Live At:</strong> {fmt(row.original.jobLiveAt)}
            </Box>
            <span><strong>Updated:</strong> {fmt(row.original.updatedAt)}</span>
          </Box>
        );
      },
    },
    {
      accessorKey: "company_name",
      header: "Company Name",
      size: 200,
      accessorFn: (row) => row.companyName,
    },
    {
      accessorKey: "action 1",
      header: "Action",
      size: 250,
      enableColumnActions: false,
      enableColumnFilter: false,
      Cell: ({ row }) => {
        return (
          <Box style={{ display: "flex", gap: "2rem" }}>
            {canUpdate && (
              <Button
                variant="contained"
                className="newBtns"
                color="primary"
                onClick={() => {
                  navigate("/all-jobs/view-job", { state: row.original._id });
                }}
              >
                View
              </Button>
            )}
            {canUpdate && (
              <Button
                variant="contained"
                className="newBtns"
                color="error"
                onClick={() => {
                  setJobRejectionForm(true);
                  setRejectingJob(row.original._id);
                }}
              >
                Reject
              </Button>
            )}
          </Box>
        );
      },
    },
  ];

  const getAllJobs = async () => {
    // Cancel any previous in-flight request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    if (!allJobsData.length) {
      setLoadingDataInGrid(true);
    } else {
      setIsRefetching(true);
    }

    try {
      const filterParams = {
        ...Object.fromEntries(
          columnFilters.map((filter) => [filter.id, filter.value])
        ),
      };

      if (filterParams.jobId) {
        filterParams.jobId = filterParams.jobId.toUpperCase();
      }

      const filterQueryString = new URLSearchParams(filterParams).toString();
      const baseUrl = `admin/job?page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&${filterQueryString}`;
      const statusQuery = tabvalue === 0 ? "status=active" : "status=pending";

      const response = await getRequestWithToken(`${baseUrl}&${statusQuery}`, { signal: controller.signal });

      if (controller.signal.aborted) return;

      setAllJobsData(response?.data?.data);
      setRowCount(response?.data?.totalcount ? response?.data?.totalcount : 0);
      setIsError(false);
      setLoadingDataInGrid(false);
      setIsTheDataLoaded(true);
    } catch (error) {
      if (error?.name === "AbortError" || error?.code === "ERR_CANCELED") return;
      setIsError(true);
      handleSnackBar(
        true,
        error?.response?.data?.message || error?.message,
        "error"
      );
      setLoadingDataInGrid(false);
      setIsTheDataLoaded(false);
    } finally {
      if (!controller.signal.aborted) {
        setLoadingDataInGrid(false);
        setIsRefetching(false);
      }
    }
  };

  const checkPermissionFunc = () => {
    const resourceToUpdate = tabvalue === 0 ? "All Jobs" : "Pending Jobs";
    const permissions = checkPermission(resourceToUpdate);
    // setCanCreate(permissions.canCreate);
    // setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes(tabvalue === 0 ? "All Jobs" : "Pending Jobs"));
  };

  useEffect(() => {
    // getAllJobs();
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue]);

  const previousTabValue = useRef(tabvalue);
  const topScrollRef = useRef(null);
  const tableContainerRef = useRef(null);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const topEl = topScrollRef.current;
    const tableEl = tableContainerRef.current;
    if (!topEl || !tableEl) return;

    const syncFromTop = () => { tableEl.scrollLeft = topEl.scrollLeft; };
    const syncFromTable = () => { topEl.scrollLeft = tableEl.scrollLeft; };

    topEl.addEventListener("scroll", syncFromTop);
    tableEl.addEventListener("scroll", syncFromTable);
    return () => {
      topEl.removeEventListener("scroll", syncFromTop);
      tableEl.removeEventListener("scroll", syncFromTable);
    };
  }, [isTheDataLoaded]);

  useEffect(() => {
    previousTabValue.current = tabvalue;
    getAllJobs();
  }, [
    tabvalue,
    columnFilters,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const handleSubmit = async (values, { resetForm }) => {
    if (values.button_action === "submit_data") {
      let formData = new FormData();
      formData = {
        reject: true,
        comments: values.comments,
      };
      try {
        let res = await patchRequestWithToken(
          `admin/job/${rejectingJob}`,
          formData
        );
        if (res.data.status === "Success") {
          setFormSubmitted(false);
          resetForm();
          handleSnackBar(true, res.data.msg, "success");
          setJobRejectionForm(false);
          getAllJobs();
        } else {
          setFormSubmitted(false);
          handleSnackBar(true, res.data.msg, "error");
        }
      } catch (err) {
        console.log(err);
        setFormSubmitted(false);
        handleSnackBar(true, err?.response?.data?.msg, "error");
      }
    }
    if (values.button_action === "cancel_submission") {
      setJobRejectionForm(false);
    }
  };


  const [showColumnFilters, setShowColumnFilters] = useState(false);

  const table = useMaterialReactTable({
    columns: useMemo(() => (tabvalue === 0 ? columns : requestedColumns), [tabvalue, canRead]),
    data: allJobsData,
    initialState: { showColumnFilters: false, density: "compact" },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableDensityToggle: true,
    enableColumnResizing: true,
    muiTableBodyCellProps: {
      sx: {
        py: "4px",
        px: "8px",
        fontSize: "0.78rem",
        borderBottom: "1px solid rgba(0, 0, 0, 0.07)",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        py: "6px",
        px: "8px",
        fontSize: "0.78rem",
        backgroundColor: "rgba(122, 75, 117, 0.08)",
        borderBottom: "2px solid rgba(122, 75, 117, 0.25)",
        fontWeight: 700,
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        backgroundColor: row.index % 2 === 0 ? "#ffffff" : "rgba(0, 0, 0, 0.018)",
        "&:hover": {
          backgroundColor: "rgba(122, 75, 117, 0.06) !important",
          cursor: "default",
        },
        transition: "background-color 0.15s ease",
      },
    }),
    muiTableContainerProps: {
      ref: tableContainerRef,
      sx: { borderRadius: "8px", border: "1px solid rgba(0,0,0,0.08)" },
    },
    enableGlobalFilter: false,
    enableSorting: false,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      sx: {
        height: "4px",
        backgroundColor: "rgba(122, 75, 117, 0.15)",
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#7a4b75",
        },
      },
    },
    muiCircularProgressProps: {
      size: 36,
      thickness: 4,
      sx: { color: "#7a4b75" },
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    // onColumnFiltersChange: setColumnFilters,
    onColumnFiltersChange: (updater) => {
      setColumnFilters(updater);
      // If you want to automatically show filters when user sets them
      setShowColumnFilters(true);
    },
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onShowColumnFiltersChange: setShowColumnFilters,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInGrid,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
      showColumnFilters
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount / pageSize);
      console.log(pageIndex, totalPages, "Pagination Info");
      console.log(rowCount, pageSize, "Pagination Info");
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning;
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${pinnedColumns.left.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${pinnedColumns.right.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });

  return ((isIncludesValue) ? (
    <Box className="jobs-section">
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          p: 2,
          borderRadius: 3,
          background: "rgba(255, 255, 255, 0.85)",
          boxShadow: "0 10px 24px rgba(50, 30, 60, 0.08)",
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Jobs
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review live and pending job postings.
          </Typography>
        </Box>
        <Chip
          label={tabvalue === 0 ? "Active" : "Pending"}
          sx={{
            bgcolor: "rgba(122, 75, 117, 0.12)",
            color: "#7a4b75",
            fontWeight: 600,
          }}
        />
      </Box> */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={jobApproved}
        autoHideDuration={1000}
        onClose={() => setJobApproved(false)}
      >
        <Alert severity="success">
          You have successfully approved the job.
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={jobRejected}
        autoHideDuration={1000}
        onClose={() => setJobRejected(false)}
      >
        <Alert severity="success">
          You have successfully rejected the job.
        </Alert>
      </Snackbar>

      <Modal open={jobRejectionForm} className="job-rejection-modal">
        <Box className="job-rejection-form-outerwrapper">
          <Box className="job-rejection-form-wrapper">
            <Box className="job-rejection-form-topsection">
              <CloseIcon onClick={() => setJobRejectionForm(false)} />
            </Box>
            <Formik
              initialValues={{ comments: "" }}
              validationSchema={UpdateJobRejectValidationSchema}
              onSubmit={handleSubmit}
            >
              {({ errors, setFieldValue }) => (
                <Form className="job-rejection-form">
                  <Box className="form-control">
                    <label className="form-label" htmlFor="comments">
                      {" "}
                      Comments
                    </label>
                    <Field
                      id="comments"
                      as="textarea"
                      placeholder="Enter comments"
                      name="comments"
                      className="form-input"
                      rows="3"
                    />
                    {errors.comments && (
                      <Box className="form-error">{errors.comments}</Box>
                    )}
                  </Box>

                  <Box className="form-button-section">
                    <Button
                      className="form-button"
                      variant="contained"
                      type="submit"
                      color="success"
                      disabled={formSubmitted}
                      onClick={() =>
                        setFieldValue("button_action", "submit_data")
                      }
                    >
                      Reject
                    </Button>
                    <Button
                      className="form-button"
                      variant="contained"
                      type="submit"
                      color="error"
                      onClick={() =>
                        setFieldValue("button_action", "cancel_submission")
                      }
                    >
                      Cancel
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Box>
      </Modal>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            px: 2,
            py: 1,
            borderRadius: 3,
            background: "rgba(255, 255, 255, 0.85)",
            boxShadow: "0 10px 24px rgba(50, 30, 60, 0.08)",
            mb: 2,
          }}
        >
          <Tabs
            value={tabvalue}
            onChange={currentTabSelect}
            aria-label="basic tabs example"
          >
            <Tab
              label="Active Jobs"
              style={{ fontWeight: "700" }}
              {...a11yProps(0)}
            />
            {isAccess.includes("Pending Jobs") && (
              <Tab
                label="Pending Jobs"
                style={{ fontWeight: "700" }}
                {...a11yProps(1)}
              />
            )}
          </Tabs>
        </Box>

        <Box className="jobs-section-data">
          {isTheDataLoaded ? (
            <>
              <Box
                ref={topScrollRef}
                sx={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  height: "10px",
                  mb: "2px",
                  "&::-webkit-scrollbar": { height: "6px" },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(122, 75, 117, 0.4)",
                    borderRadius: "4px",
                  },
                  "&::-webkit-scrollbar-track": { backgroundColor: "rgba(0,0,0,0.05)" },
                }}
              >
                <Box sx={{ width: tableContainerRef.current?.scrollWidth ?? "200%", height: "1px" }} />
              </Box>
              <DataTable table={table} />
            </>
          ) : (
            <Box
              sx={{
                width: "100%",
                minHeight: "300px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                bgcolor: "rgba(255,255,255,0.85)",
                borderRadius: 2,
                border: "1px solid rgba(0,0,0,0.07)",
              }}
            >
              <CircularProgress
                size={48}
                thickness={4}
                sx={{ color: "#7a4b75" }}
              />
              <Typography variant="body2" color="text.secondary">
                Loading jobs...
              </Typography>
            </Box>
          )}
        </Box>

      </Box>
    </Box>
  ) :
    (<Unauthorized />)
  );
};

export default AllJobs;
